import React, { useCallback, useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Button } from '@material-ui/core';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      marginLeft: '10px',
      marginRight: '10px',
      background: theme.brand,
      color: 'white',
      '&:hover': {
        background: '#228B22',
      },
    },
  })
);

var response = {
  code: 100,
  data: {
    firstName: '',
    lastName: '',
    roomName: '',
  },
};

export default function MuteAllButton(props: { className?: string }) {
  const [count, setCount] = useState(0);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        data-cy-join-now
        onClick={muteAllButton1}
        disabled={count == 0 ? false : true}
      >
        {count == 0 ? 'Mute All' : 'Muted'}
      </Button>
    </>
  );

  function muteAllButton1() {
    setCount(1);
    setTimeout(() => {
      setCount(0);
    }, 5000);

    const queryParams = new URLSearchParams(window.location.search);
    const uid = queryParams.get('uid');

    const fullAPI = `${process.env.REACT_APP_ENDPOINT}/twillio/muteall?` + 'uuid=' + uid;

    fetch(fullAPI)
      .then(res => res.json())
      .then(booksList => {
        response.data = booksList;

        console.log('Sharad', 'Mute');
      })
      .catch(console.log);
  }
}
